const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantContact',
            'restaurant': null,
            'userId': null,
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.userId = this.settings.userId;

        this.$form = $('<form/>')
        .addClass('restaurant-user-form');

        if(this.userId){
            this.loadData();
        }else{
            this.user = {
                'id': null,
                'login': '',
                'email': '',
                'firstName': '',
                'lastName': '',
                'softwareAccess': true,
                'contacts': [{
                    'job': '',
                    'phone': '',
                    'mobile': '',
                    'comment': '',
                    'newsletterAccepted': false,
                    'promosAccepted': false,
                }]
            };
            this.fillForm();
        }

        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getForm(){
        return this.$form;
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildUserQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildUserQuery(){
        var self = this;

        let id = this.userId;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'login',
            'email',
            'firstName',
            'lastName',
            'softwareAccess',
            'contacts { restaurant { id } job phone mobile comment newsletterAccepted promosAccepted }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'user',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    fillForm(data){
        if(data){
            this.user = data.user;
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(window.translate('app.restaurant.show.tabs.user.save.label'));

        this.$form
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .addClass('mt-2')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    buildInputs(){
        var self = this;    
        let $box = $('<div/>');

        let contact = {
            'job': '',
            'phone': '',
            'mobile': '',
            'comment': '',
            'newsletterAccepted': false,
            'promosAccepted': false,
        };
        if(this.user.contacts.length > 0){
            if(this.user.contacts.length == 1){
                contact = this.user.contacts[0];
            }else{
                for(var i in this.user.contacts){
                    let actualContact = this.user.contacts[i];
                    let idRestaurant = actualContact.restaurant.id;
                    if(idRestaurant == this.restaurant.id){
                        contact = actualContact;
                    }
                }
            }
        }
        
        //FIELD login
        let $loginLabel = $('<label/>')
        .attr('for','login')
        .append(window.translate('app.restaurant.show.tabs.user.login.label'));
        let $loginInput = $('<input/>')
        .attr('autocomplete','new-login')
        .attr('required','required')
        .attr('type','text')
        .attr('name','login')
        .addClass('form-control')
        .val(this.user.login);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($loginLabel)
            .append($loginInput)
        );

        //FIELD email
        let $emailLabel = $('<label/>')
        .attr('for','email')
        .append(window.translate('app.restaurant.show.tabs.user.email.label'));
        let $emailInput = $('<input/>')
        .attr('required','required')
        .attr('type','text')
        .attr('name','email')
        .addClass('form-control')
        .val(this.user.email);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($emailLabel)
            .append($emailInput)
        );



        let $passwordLabel = $('<label/>')
        .attr('for','password')
        .append(window.translate('app.restaurant.show.tabs.user.password.label'));
        let $passwordConfirmLabel = $('<label/>')
        .attr('for','passwordConfirm')
        .append(window.translate('app.restaurant.show.tabs.user.passwordConfirm.label'));

        this.$passwordInput = $('<input/>')
        .attr('autocomplete','new-password')
        .attr('type','password')
        .attr('id','password')
        .attr('name','password')
        .addClass('form-control')
        .on('change',function(){
            self.checkPassword();
        });

        this.$passwordConfirmInput = $('<input/>')
        .attr('autocomplete','new-password')
        .attr('type','password')
        .attr('id','passwordConfirm')
        .attr('name','passwordConfirm')
        .addClass('form-control')
        .on('change',function(){
            self.checkPassword();
        });
        this.$passwordMessage = $('<small/>')
        .hide()
        .addClass('text-danger')

        let $passwordContainer = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-6 form-group')
            .append($passwordLabel)
            .append(this.$passwordInput)
        )
        .append(
            $('<div/>')
            .addClass('col-6 ps-2 form-group')
            .append($passwordConfirmLabel)
            .append(this.$passwordConfirmInput)
        )
        .append(
            $('<div/>')
            .addClass('col-12 d-flex justify-content-center')
            .append(
                this.$passwordMessage
            )
        );

        if(!this.user.id){
            this.$passwordInput.attr('required','required');
            this.$passwordConfirmInput.attr('required','required');
        }

        $box.append($passwordContainer);

        //FIELD firstName
        let $firstNameLabel = $('<label/>')
        .attr('for','firstName')
        .append(window.translate('app.restaurant.show.tabs.user.firstName.label'));
        let $firstNameInput = $('<input/>')
        .attr('required','required')
        .attr('type','text')
        .attr('name','firstName')
        .addClass('form-control')
        .val(this.user.firstName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($firstNameLabel)
            .append($firstNameInput)
        );

        //FIELD lastName
        let $lastNameLabel = $('<label/>')
        .attr('for','lastName')
        .append(window.translate('app.restaurant.show.tabs.user.lastName.label'));
        let $lastNameInput = $('<input/>')
        .attr('required','required')
        .attr('type','text')
        .attr('name','lastName')
        .addClass('form-control')
        .val(this.user.lastName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($lastNameLabel)
            .append($lastNameInput)
        );

        //FIELD job
        let $jobLabel = $('<label/>')
        .attr('for','job')
        .append(window.translate('app.restaurant.show.tabs.user.job.label'));
        let $jobInput = $('<input/>')
        .attr('type','text')
        .attr('name','job')
        .addClass('form-control')
        .val(window.htmldecode(contact.job));
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($jobLabel)
            .append($jobInput)
        );

        //FIELD phone
        let $phoneLabel = $('<label/>')
        .attr('for','phone')
        .append(window.translate('app.restaurant.show.tabs.user.phone.label'));
        let $phoneInput = $('<input/>')
        .attr('type','text')
        .attr('name','phone')
        .addClass('form-control')
        .val(contact.phone);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($phoneLabel)
            .append($phoneInput)
        );

        //FIELD mobile
        let $mobileLabel = $('<label/>')
        .attr('for','mobile')
        .append(window.translate('app.restaurant.show.tabs.user.mobile.label'));
        let $mobileInput = $('<input/>')
        .attr('type','text')
        .attr('name','mobile')
        .addClass('form-control')
        .val(contact.mobile);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($mobileLabel)
            .append($mobileInput)
        );

        //FIELD comment
        let $commentLabel = $('<label/>')
        .attr('for','comment')
        .append(window.translate('app.restaurant.show.tabs.user.comment.label'));
        let $commentInput = $('<textarea/>')
        .attr('type','text')
        .attr('name','comment')
        .addClass('form-control')
        .append(window.htmldecode(contact.comment));
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($commentLabel)
            .append($commentInput)
        );


        // FIELD newsletterAccepted
        let $newsletterAcceptedLabel = $('<label/>')
        .attr('for','newsletterAccepted')
        .addClass('form-check-label')
        .append(window.translate('app.restaurant.show.tabs.user.newsletterAccepted.label'));
        this.$newsletterAcceptedInput = $('<input/>')
        .attr('id','newsletterAccepted')
        .attr('name','newsletterAccepted')
        .attr('type','checkbox')
        .addClass('form-check-input form-check-input-checked-success')
        .val(1);
        if(contact.newsletterAccepted){
            this.$newsletterAcceptedInput.prop('checked',true);
        }

        let $newsletterAcceptedSwitch = $('<div/>')
        .addClass('form-check form-switch')
        .append(this.$newsletterAcceptedInput)
        .append($newsletterAcceptedLabel);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($newsletterAcceptedSwitch)
        );

        // FIELD promosAccepted
        let $promosAcceptedLabel = $('<label/>')
        .attr('for','promosAccepted')
        .addClass('form-check-label')
        .append(window.translate('app.restaurant.show.tabs.user.promosAccepted.label'));
        this.$promosAcceptedInput = $('<input/>')
        .attr('id','promosAccepted')
        .attr('name','promosAccepted')
        .attr('type','checkbox')
        .addClass('form-check-input form-check-input-checked-success')
        .val(1);
        if(contact.promosAccepted){
            this.$promosAcceptedInput.prop('checked',true);
        }

        let $promosAcceptedSwitch = $('<div/>')
        .addClass('form-check form-switch')
        .append(this.$promosAcceptedInput)
        .append($promosAcceptedLabel);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($promosAcceptedSwitch)
        );

        // FIELD softwareAccess
        let $softwareAccessLabel = $('<label/>')
        .attr('for','softwareAccess')
        .addClass('form-check-label')
        .append(window.translate('app.restaurant.show.tabs.user.softwareAccess.label'));
        this.$softwareAccessInput = $('<input/>')
        .attr('id','softwareAccess')
        .attr('name','softwareAccess')
        .attr('type','checkbox')
        .addClass('form-check-input form-check-input-checked-success form-check-input-unchecked-danger')
        .val(1);
        if(this.user.softwareAccess && this.user.softwareAccess == 1){
            this.$softwareAccessInput.prop('checked',true);
        }

        let $softwareAccessSwitch = $('<div/>')
        .addClass('form-check form-switch')
        .append(this.$softwareAccessInput)
        .append($softwareAccessLabel);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($softwareAccessSwitch)
        );

        return $box;
    }

    onDOMReady(){
        super.onDOMReady();
    }

    getFields(){
        let fields = super.getFields();
        fields.push('contact { user { id }}');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        if(this.user.id){
            variables.user = {
                'value': this.user.id,
                'type': 'Int'
            };
        }

        return variables;
    }

    isValid(){
        this.checkPassword();

        return super.isValid();
    }

    getData(){
        let formData = super.getData();
        if(!this.$newsletterAcceptedInput.is(':checked')){
            formData.append(this.$newsletterAcceptedInput.attr('name'),0);
        }
        if(!this.$promosAcceptedInput.is(':checked')){
            formData.append(this.$promosAcceptedInput.attr('name'),0);
        }
        if(!this.$softwareAccessInput.is(':checked')){
            formData.append(this.$softwareAccessInput.attr('name'),0);
        }
        return formData;
    }

    checkPassword(){
        this.$form.removeClass('was-validated');
        
        this.$passwordMessage.html('').hide();

        this.$passwordInput[0].setCustomValidity('');
        this.$passwordConfirmInput[0].setCustomValidity('');

        if(this.$passwordInput.val()){
            this.$passwordInput.attr('required','required');
            this.$passwordConfirmInput.attr('required','required');
        }else{
            if(this.user.id){
                this.$passwordInput.removeAttr('required');
                this.$passwordConfirmInput.removeAttr('required');
            }
        }

        if(this.$passwordInput.val() && this.$passwordConfirmInput.val()){
            if(this.$passwordInput.val() != this.$passwordConfirmInput.val()){
                let error = window.translate('passwordMissmatch');
                this.$passwordInput[0].setCustomValidity(error);
                this.$passwordConfirmInput[0].setCustomValidity(error);
                this.$passwordMessage.append(error).show();
                this.$form.addClass('was-validated');
            }
        }
    }

}

module.exports = Form;

